export const FILL_VALUES: Record<string, string> = {
  date_issued: '2026-08-07',
  policy_effective_date: '2026-04-01',
  policy_expiry_date: '2027-04-01',
  policy_term: '12 months',
  issuer_name_and_address_1: 'Carrefour Risk Partners inc.',
  issuer_name_and_address_2: '350 avenue du Courtier',
  issuer_name_and_address_3: 'Montréal (Québec) H2Y 0A7',
  issuer_email: 'certificates@carrefourrisk.example',
  issuer_telephone: '514 555 0193',
  insured_name_and_address_1: 'Boréal Ateliers Verdun inc.',
  insured_name_and_address_2: "4820 rue de l'Atelier, Suite 210, Montréal (Québec) H4G 2K1",
  insured_registration_number: '9999 8887 77',
  insured_operations: 'Manufacture and installation of custom cabinetry and architectural millwork',
  row1_description:
    'Commercial General Liability - Each occurrence 2 000 000 $ / General aggregate 5 000 000 $',
  row1_basis: 'Occurrence',
  row1_limit: '2 000 000 $',
  row2_description:
    'Non-Owned and Hired Automobile - Combined single limit each accident 2 000 000 $',
  row2_basis: 'Occurrence',
  row2_limit: '2 000 000 $',
  row3_description: 'Commercial Property - all risks',
  row3_basis: 'Replacement cost',
  row3_limit: '2 400 000 $',
  row4_description: 'Equipment Breakdown',
  row4_basis: 'Repair or replace',
  row4_limit: '2 000 000 $',
  row5_description: 'Umbrella Liability - Each occurrence / Aggregate',
  row5_basis: 'Occurrence',
  row5_limit: '5 000 000 $',
  remarks_1: 'Property damage deductible (each occurrence): 2 500 $',
  remarks_2: 'Hired automobile deductible: 1 000 $',
  remarks_3:
    'Property deductible (each occurrence): 5 000 $ / Umbrella self-insured retention: 10 000 $',
  remarks_4:
    "Insured locations: 01 - 4820 rue de l'Atelier, Suite 210, Montréal H4G 2K1; 02 - 1190 boulevard des Copeaux, Laval H7L 3V8; 03 - 77 rue Principale Est, Unit 4, Sherbrooke J1H 1B2",
}
